var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c(
        "TableList",
        {
          staticStyle: { "min-height": "80vh" },
          attrs: {
            columns: _vm.tabPaneConfig[0].columns,
            tableData: _vm.tabPaneConfig[0].tableData,
            loading: _vm.tabPaneConfig[0].loading,
            scroll: {},
            pagination: _vm.tabPaneConfig[0].pagination,
          },
          on: { change: _vm.handleTableChange },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function ({ record }) {
                return [
                  _c(
                    "div",
                    { staticClass: "action-detail" },
                    [
                      _c(
                        "span",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.commentClick(record)
                            },
                          },
                        },
                        [_vm._v("点评")]
                      ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "span",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.viewArchives(record)
                            },
                          },
                        },
                        [_vm._v("查看档案")]
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "div",
            {
              staticClass: "query-area",
              attrs: { slot: "queryArea" },
              slot: "queryArea",
            },
            [
              _c(
                "div",
                [
                  _c("j-dict-select-tag", {
                    staticStyle: { width: "170px", "margin-right": "15px" },
                    attrs: {
                      placeholder: "请选择年级",
                      dictCode:
                        "school_grade,grade_name,id,0=delete_flag order by sort_order",
                      isShowEmpty: false,
                    },
                    on: {
                      select: function ($event) {
                        return _vm.$set(_vm.queryParam, "classId", undefined)
                      },
                    },
                    model: {
                      value: _vm.queryParam.gradeId,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParam, "gradeId", $$v)
                      },
                      expression: "queryParam.gradeId",
                    },
                  }),
                  _c("j-dict-select-tag", {
                    staticStyle: { width: "170px", "margin-right": "15px" },
                    attrs: {
                      placeholder: "请选择班级",
                      dictCode:
                        "school_class,name,id,grade_id=" +
                        (!_vm.queryParam.gradeId ? -1 : _vm.queryParam.gradeId),
                      async: true,
                      disabled: !_vm.queryParam.gradeId,
                      isShowEmpty: false,
                    },
                    model: {
                      value: _vm.queryParam.classId,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParam, "classId", $$v)
                      },
                      expression: "queryParam.classId",
                    },
                  }),
                  _c("a-range-picker", {
                    staticClass: "search-space",
                    staticStyle: { width: "240px" },
                    model: {
                      value: _vm.dateRange,
                      callback: function ($$v) {
                        _vm.dateRange = $$v
                      },
                      expression: "dateRange",
                    },
                  }),
                  _c("j-dict-select-tag", {
                    staticClass: "search-space",
                    attrs: { placeholder: "关爱等级", dictCode: "care_list" },
                    model: {
                      value: _vm.queryParam.careList,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParam, "careList", $$v)
                      },
                      expression: "queryParam.careList",
                    },
                  }),
                  _c("a-input-search", {
                    staticClass: "search-space",
                    staticStyle: { width: "170px" },
                    attrs: { placeholder: "请输入学生名字" },
                    on: { change: _vm.searchName },
                    model: {
                      value: _vm.queryParam.studentName,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParam, "studentName", $$v)
                      },
                      expression: "queryParam.studentName",
                    },
                  }),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.queryTable },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
              _c(
                "a-button",
                {
                  staticStyle: { "margin-left": "auto" },
                  attrs: { type: "primary", icon: "download" },
                  on: {
                    click: function ($event) {
                      return _vm.handleExportXls("重点关爱学生干预情况统计")
                    },
                  },
                },
                [_vm._v("\n        导出\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("CommentModal", {
        ref: "commentModalRef",
        on: { refreshData: _vm.loadData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }